/* globals L */
import React from "react";
import { Marker, Popup } from "react-leaflet";
import { withGlobalContext } from "./GlobalContext";
import Loading from "./Loading";
import InfoWindow from "./InfoWindow";

const StyledMarker = (props) => {
  var pushpinHtml = L.divIcon({
    className: props.classes.mapPin,
    html: `<span class="${props.classes.priceLabel}">${props.label}</span>`,
  });
  return (
    <div>
      <Marker {...props} icon={pushpinHtml}>
        <Popup className={props.classes.popup}>
          {!props.activeListing ? (
            <Loading size={80} className={props.classes.loader} />
          ) : props.markerId === props.activeListing.id ? (
            <InfoWindow {...props} activeListing={props.activeListing} />
          ) : null}
        </Popup>
      </Marker>
    </div>
  );
};

export default withGlobalContext(StyledMarker);
